var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.emailLinked)?_c('v-alert',{attrs:{"dense":"","type":"warning"}},[_c('span',[_vm._v("Email not linked. You cannot send mail. "),_c('router-link',{attrs:{"to":{ name: 'account' }}},[_vm._v("Please set you password here.")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }